import "./style/Login.css";
import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthContext, AuthProvider } from "./auth/AuthProvider";

import "./style/Login.css";
import LoadingSpinner from "./loadingSpinner/LoadingSpinner.jsx";
export default function Login() {
  const { email, setEmail, fetchUser } = useContext(AuthContext);
  const {
    setStorage,
    user,
    googleUser,
    setUser,
    prevLocation,
    redirection,
    themeSlug,
    setPrevLocation,
    payed,
    apiUrl,
  } = useContext(AuthContext);

  const location = useLocation();

  const [error, setError] = useState("");
  const [exist, setExist] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [op, setOp] = useState(null);
  const [code, setCode] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  const [userInfo1, setUserInfo1] = useState(null);

  const [validCode, setValidCode] = useState("");
  const [codeError, setCodeError] = useState("");

  // const { loading, setLoading } = useContext(AuthContext);
  const [loading, setLoading] = useState(false); // ✅ local loading
  const { id } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    if (user !== null) {
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("hero-text1");
          observer.unobserve(entry.target);
        }
      });
    });

    document.querySelectorAll(".loginSection").forEach((element) => {
      observer.observe(element);
    });
  }, [user, googleUser, setStorage, navigate, themeSlug]);

  useEffect(() => {
    const redirect = localStorage.getItem("postLoginRedirect");

    if (googleUser || user) {
      navigate(redirect || "/", { replace: true });
      localStorage.removeItem("postLoginRedirect");
    }
  }, [googleUser, user]);

  function googleButton() {
    // console.log(apiUrl);
    // window.location.href =
    //   "https://api.introspecta.app/oauth2/authorization/google";
    window.location.href = `${apiUrl}/oauth2/authorization/google`;
  }

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    const formInfo = {
      email: email,
    };

    axios
      .post(apiUrl + "/api/auth/login", formInfo, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data !== null) {
          // setUser(response.data);

          setUserInfo(response.data);
        }
        setOp(null);
        setError("");
      })
      .catch((e) => {
        setExist(true);
        setOp(e);
        setError("User doesn't exist!");
      })
      .finally(() => setLoading(false));
  }

  function handleSubmit1(e) {
    e.preventDefault();

    setLoading(true);

    // setUserInfo(null);
    const verCode = {
      email: email,
      verificationCode: code,
    };

    axios
      .post(apiUrl + "/api/auth/verify", verCode)
      .then((response) => {
        if (response.data !== null) {
          // setUserInfo1(response.data);
          setUser(response.data);

          // if (response.data.verificationCode !== verCode.verificationCode) {
          //   setCodeError("Invalid Code!");
          // } else {
          setLoading(false);
          setCodeError("");
          setCode("");
          const redirect = localStorage.getItem("postLoginRedirect");

          navigate(redirect || "/");

          // localStorage.removeItem("postLoginRedirect");
          // navigate("/login");

          // }
        }
      })
      .catch((e) => {
        setCodeError(e.response.data.error);
        setCode("");

        setExist(true);
        // setError("Username or Email already exist!");
        console.error(e);
      })
      .finally(() => setLoading(false));
  }

  function handleSubmit2(e) {
    e.preventDefault();

    setLoading(true);

    const resendCode = {
      email: email,
    };

    const firstPartEmail = resendCode.email.split("@");

    axios
      .post(
        `${apiUrl}/api/auth/resend?email=${firstPartEmail[0]}%40${firstPartEmail[1]}`,
        resendCode,
      )
      .then((response) => {
        setLoading(false);
        setCodeError("");
        setCode("");
      })
      .catch((e) => {
        console.error(e);
        setCode("");
      })
      .finally(() => setLoading(false));
  }

  function handleCheckbox() {
    const checkbox = document.getElementById("legal-confirmation-submit");

    if (checkbox.checked) setIsChecked(true);
    else setIsChecked(false);
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <section className="loginSection signup-page">
        <div id="goBackContainer">
          <Link to={localStorage.getItem("postLoginRedirect") || "/"}>
            <button id="goBackBtn">←</button>
          </Link>
        </div>
        <div className="signup-container">
          {!userInfo && (
            <form onSubmit={handleSubmit}>
              <label>Enter your Email:</label>
              <br></br>
              <input
                type="email"
                name="lEmail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  borderColor: exist ? "red" : "",
                  boxShadow: exist ? "0 0 10px red" : "",
                }}
                // className={`${exist ? "lEmail" : ""}`}
              />
              {exist ? (
                <p
                  style={{ color: "red", marginBottom: "0" }}
                  className="invalidCode"
                >
                  {error}
                </p>
              ) : (
                ""
              )}
              {isChecked ? (
                <input
                  type="submit"
                  value={"Submit"}
                  className="submit-type-btn"
                />
              ) : (
                <input
                  type="submit"
                  value={"Submit"}
                  className="submit-type-btn"
                  disabled
                />
              )}
              <div
                style={{
                  position: "relative",
                  top: "20px",
                }}
              >
                <p>
                  Don't have an account?{" "}
                  <Link to={"/signup"}>Sign Up Here</Link>
                </p>
              </div>
              <hr />

              <div className="legal-confirmation">
                <p style={{ marginBottom: "0", fontFamily: "helvetica" }}>
                  <input
                    type="checkbox"
                    id="legal-confirmation-submit"
                    onClick={handleCheckbox}
                  />
                  By clicking Submit, you agree to Introspecta's{" "}
                  <Link to={"/terms"}>Terms and Conditions</Link> and{" "}
                  <Link to={"/privacy"}>Privacy Policy</Link>.
                </p>
              </div>
            </form>
          )}

          {userInfo && (
            <>
              <form onSubmit={handleSubmit1}>
                <label>Email verification code for {userInfo.email}</label>
                <br></br>
                <input
                  type="text"
                  name="code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                />
                {exist ? (
                  <p
                    className="invalidCode"
                    style={{ color: "red", marginBottom: "0" }}
                  >
                    {codeError}
                  </p>
                ) : (
                  ""
                )}
                <input
                  type="submit"
                  value={"Verify Email"}
                  className="submit-type-btn"
                  // style={{ fontSize: "20px" }}
                />
              </form>
              <form onSubmit={handleSubmit2}>
                <input type="submit" value={"Resend Code"} id="resendCode" />
              </form>
              <div
                style={{
                  position: "relative",
                  top: "20px",
                }}
              >
                <p>
                  Don't have an account?{" "}
                  <Link to={"/signup"}>Sign Up Here</Link>
                </p>
              </div>
            </>
          )}
          {/* <div
            style={{
              position: "relative",
              top: "20px",
            }}
          >
            <p>
              Don't have an account? <Link to={"/signup"}>Sign Up Here</Link>
            </p>
          </div>
          <hr />

          <div className="legal-confirmation">
            <p style={{ marginBottom: "0", fontFamily: "helvetica" }}>
              <input
                type="checkbox"
                id="legal-confirmation-submit"
                onClick={handleCheckbox}
              />
              By clicking Submit, you agree to Introspecta's{" "}
              <Link to={"/terms"}>Terms and Conditions</Link> and{" "}
              <Link to={"/privacy"}>Privacy Policy</Link>.
            </p>
          </div> */}
          {/* {userInfo && navigate("/")} */}
          <div style={{ paddingTop: "5px" }}>
            <button
              type="button"
              className="login-with-google-btn"
              onClick={googleButton}
            >
              {/* <svg>
              https://image.similarpng.com/file/similarpng/very-thumbnail/2020/12/Illustration-of-Google-icon-on-transparent-background-PNG.png
            </svg> */}
              <img src="google.png" width={30} height={30} alt="google" />
              Sign in with Google
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
